import * as constants from './actions';

const initialState = {
    message: [],
    topic: []
};

const preservedFields = [
    'address',
    'county',
    'country',
    'day',
    'email',
    'firstName',
    'fullName',
    'homeAddress',
    'homeCity',
    'lastName',
    'message',
    'middleName',
    'month',
    'phone',
    'postalCode',
    'prefix',
    'stateId',
    'street',
    'streetNo',
    'suffix',
    'topic',
    'unit',
    'year'
];

export default function cacheFormData(state = initialState, { type, payload }) {
    switch (type) {
        case constants.CACHE_FORM_DATA:
            const matchedKeys =
                Object.keys(payload.values || {})
                    .filter(f => preservedFields.includes(f))
                    .reduce((obj, key) => {
                        if (key === 'topic' || key === 'message') {
                            const existingItem = state[key]
                                .map(e => e.actionIdentifier)
                                .indexOf(payload.actionIdentifier);

                            if (existingItem === -1) {
                                obj[key] = state[key].concat({
                                    title: payload.values[key],
                                    actionIdentifier: payload.actionIdentifier
                                });
                            } else {
                                state[key][existingItem] = {
                                    title: payload.values[key],
                                    actionIdentifier: payload.actionIdentifier
                                };
                            }
                        } else {
                            obj[key] = payload.values[key];
                        }
                        return obj;
                    }, {}) || {};
            return {
                ...state,
                ...matchedKeys
            };
        default:
            return state;
    }
}
